import { theme } from '../../themes/GeneralTheme';
export const classes = {
  header: {
    display: 'flex',
    position: 'fixed',
    left: 0,
    right: 0,
    top: 0,
    zIndex: 100,
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(5, 15),
    borderBottom: `1px solid ${theme.palette.primary.light}`,
    background: theme.palette.background.default,

    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(3),
      padding: theme.spacing(5),
      fontSize: "16px",
    },
  },

};